import type { FC, SVGProps } from 'react';

import AlarmClockIcon from '@/assets/svg/alarm_clock.svg';
import BookmarkIcon from '@/assets/svg/bookmark.svg';
import DoneAllIcon from '@/assets/svg/done_all.svg';
import ProjectOutlinedIcon from '@/assets/svg/eos-icons_project-outlined.svg';
import RolePermissionIcon from '@/assets/svg/eos-icons_role-binding-outlined.svg';
import FilterIcon from '@/assets/svg/filter.svg';
import FlashIcon from '@/assets/svg/flash.svg';
import TaskFilledIcon from '@/assets/svg/fluent_clipboard-task-add-20-filled.svg';
import TicketIcon from '@/assets/svg/fluent_clipboard-task-add-20-regular.svg';
import ClipboardTaskListFilledIcon from '@/assets/svg/fluent_clipboard-task-list-16-filled.svg';
import TaskIcon from '@/assets/svg/fluent_clipboard-task-list-16-regular.svg';
import ClockBillIcon from '@/assets/svg/fluent_clock-bill-24-regular.svg';
import CustomerIcon from '@/assets/svg/fluent_people-32-regular.svg';
import CustomerFilledIcon from '@/assets/svg/fluent_people-48-filled.svg';
import ViolationIcon from '@/assets/svg/fluent_people-error-20-regular.svg';
import TaskListIcon from '@/assets/svg/fluent_task-list-square-add-20-regular.svg';
import TaskCompleteIcon from '@/assets/svg/fluent_tasks-app-28-regular.svg';
import FullScreenIcon from '@/assets/svg/full_screen.svg';
import TranslateIcon from '@/assets/svg/g_translate.svg';
import ConfigIcon from '@/assets/svg/hugeicons_configuration-01.svg';
import PencilIcon from '@/assets/svg/ic_baseline-mode.svg';
import MaterialIcon from '@/assets/svg/icon-park-outline_material.svg';
import StaffIcon from '@/assets/svg/icon-park-outline_people.svg';
import IncidentIcon from '@/assets/svg/ix_maintenance-warning.svg';
import LeftArrowIcon from '@/assets/svg/left_arrow.svg';
import ComponentIcon from '@/assets/svg/material-symbols-light_manufacturing.svg';
import DeviceIcon from '@/assets/svg/material-symbols-light_precision-manufacturing-outline.svg';
import DeviceFilldeIcon from '@/assets/svg/material-symbols-light_precision-manufacturing.svg';
import ComponentRecommendationIcon from '@/assets/svg/material-symbols_component-exchange.svg';
import ComponentRoundedIcon from '@/assets/svg/material-symbols_manufacturing-rounded.svg';
import SearchIcon from '@/assets/svg/material-symbols_search-rounded.svg';
import JobConfigIcon from '@/assets/svg/mdi_form-outline.svg';
import ReportIcon from '@/assets/svg/mdi_report-pie-outline.svg';
import CoordinationIcon from '@/assets/svg/mdi_table-question.svg';
import NotificationIcon from '@/assets/svg/notification.svg';
import PersonOutlineIcon from '@/assets/svg/person_outline.svg';
import PlusIcon from '@/assets/svg/plus.svg';
import RightArrowIcon from '@/assets/svg/right_arrow.svg';
import HomeIcon from '@/assets/svg/si_home-line.svg';
import AlarmClockSolidIcon from '@/assets/svg/streamline_alarm-clock-solid.svg';
import AccessoryIcon from '@/assets/svg/tabler_device-computer-camera.svg';
import DeviceConfigIcon from '@/assets/svg/tabler_device-ipad-cog.svg';
import ComponentConfigIcon from '@/assets/svg/tabler_device-ipad-plus.svg';
import TaskListFilledIcon from '@/assets/svg/task-list-square-add-20-filled.svg';
import ToggleSidebarIcon from '@/assets/svg/toggle_sidebar.svg';
import CalendarSolidIcon from '@/assets/svg/uis_calender.svg';
import ComponentExchangeIcon from '@assets/svg/component_exchange.svg';
import TranslationGlobalIcon from '@assets/svg/translation-global.svg';

export const iconMap: Record<string, FC<SVGProps<SVGSVGElement>>> = {
    home: HomeIcon,
    ticket: TicketIcon,
    task: TaskIcon,
    incident: IncidentIcon,
    device: DeviceIcon,
    component: ComponentIcon,
    accessory: AccessoryIcon,
    material: MaterialIcon,
    customer: CustomerIcon,
    report: ReportIcon,
    deviceConfig: DeviceConfigIcon,
    componentConfig: ComponentConfigIcon,
    jobConfig: JobConfigIcon,
    rolePermission: RolePermissionIcon,
    toggleSidebar: ToggleSidebarIcon,
    personOutline: PersonOutlineIcon,
    alarmClock: AlarmClockIcon,
    bookmark: BookmarkIcon,
    notification: NotificationIcon,
    configuration: ConfigIcon,
    plus: PlusIcon,
    search: SearchIcon,
    filter: FilterIcon,
    taskList: TaskListIcon,
    taskListFilled: TaskListFilledIcon,
    clipboardTaskListFilled: ClipboardTaskListFilledIcon,
    alarmClockSolid: AlarmClockSolidIcon,
    calendarSolid: CalendarSolidIcon,
    pencil: PencilIcon,
    flash: FlashIcon,
    staff: StaffIcon,
    deviceFilled: DeviceFilldeIcon,
    clockBill: ClockBillIcon,
    fullscreen: FullScreenIcon,
    leftArrow: LeftArrowIcon,
    rightArrow: RightArrowIcon,
    coordination: CoordinationIcon,
    violation: ViolationIcon,
    componentRecommendation: ComponentRecommendationIcon,
    taskComplete: TaskCompleteIcon,
    componentRounded: ComponentRoundedIcon,
    projectOutlined: ProjectOutlinedIcon,
    taskFilled: TaskFilledIcon,
    customerFilled: CustomerFilledIcon,
    doneAll: DoneAllIcon,
    translate: TranslateIcon,
    translationGlobal: TranslationGlobalIcon,
    componentExchange: ComponentExchangeIcon,
};
